// schema
import * as ISchema from "#webapp/src/__schema__";

import { logger } from "#webapp/src/util/logger.util";
import { requestSubscription } from "react-relay";
import { Environment } from "relay-runtime";
import { subscription } from "./UpdateFlowState.gql";

export function updateFlowStateSubscription(
  environment: Environment,
  input: ISchema.IUpdateFlowStateSubscriptionInput,
) {
  if (!(environment instanceof Environment)) {
    // don't proceed if it's not a modern environment
    return;
  }

  const variables = {
    input,
  };

  return requestSubscription(environment, {
    subscription,
    variables,
    // optional but recommended:
    onCompleted: () => logger.debug("Subscription request for FlowState completed"),
    onError: (error) => logger.error("Subscription request for FlowState failed", error),
    // updater: (store) => {
    //   // Get the notification
    //   const rootField = store.getRootField('markReadNotification');
    //   const notification = rootField.getLinkedRecord('notification');
    //   // Add it to a connection
    //   const viewer = store.getRoot().getLinkedRecord('viewer');
    //   const notifications =
    //     ConnectionHandler.getConnection(viewer, 'notifications');
    //   const edge = ConnectionHandler.createEdge(
    //     store,
    //     notifications,
    //     notification,
    //     '<TypeOfNotificationsEdge>',
    //   );
    //   ConnectionHandler.insertEdgeAfter(notifications, edge);
    // },
  });
}
